import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { v4 } from 'uuid';
import { PusherService } from 'src/app/services/defaults/pusher/pusher.service';
import { PageBase } from 'src/app/pages';
import { IonContent } from '@ionic/angular';


interface Message {
  id?: number;
  user_id: number;
  text: string;
  message?: any
}

@Component({
  selector: 'ac-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent extends PageBase implements OnInit {
  constructor(
    private http: HttpClient,
    private pusher: PusherService
  ) {
    super();
  }

  event: string = `App\\Events\\NewChatMessage`;
  messages: Array<Message> = [];
  message: string = '';
  lastMessageId;

  sendMessage() {
    if (this.message !== '') {
      // Assign an id to each outgoing message.
      // It aids in the process of differentiating between outgoing and incoming messages
      this.lastMessageId = v4();
      const data: Message = {
        id: this.lastMessageId,
        user_id: this.globalvar._user.id,
        text: this.message,
      };

      this.pusher.post(data).then((data: Message) => {
        this.message = '';
      }, err => {
        console.error(err);
      });
    }
  }

  getMessages() {
    this.pusher.get().then((data: any) => {
      data.forEach(messages => {
        const temp = messages;

        const message: any = {message: temp};

        this.messages = this.messages.concat(message);
      });

    }, err => {
      console.error(err);
    });
  }

  getClasses(messageUserId) {
    return {
      incoming: this.globalvar._user.id != messageUserId,
      outgoing: this.globalvar._user.id === messageUserId,
    };
  }

  ngOnInit() {
    this.getMessages();
    this.scrollToBottomOnInit();
    const channel = this.pusher.init();
    channel.bind(this.event, (data) => {
      const message: Message = {
        ...data,
        type: 'incoming',
      };

      this.messages = this.messages.concat(message);
    });
  }

  @ViewChild(IonContent, { static: false }) myMessageArea: IonContent;


  scrollToBottomOnInit() {
    setTimeout(() => {
      this.myMessageArea.scrollToBottom(300);
    }, 1000);
  }
}
